export default __webpack_public_path__ + "static/haengematte600px-1f60a2e10780ffe9f0f7c403bf81a552.png";